export default {
  "pbGlobal": "pbjs",
  "defineGlobal": true,
  "features": {
    "NATIVE": true,
    "VIDEO": true,
    "UID2_CSTG": true,
    "GREEDY": false,
    "AUDIO": true,
    "LOG_NON_ERROR": true,
    "LOG_ERROR": true
  },
  "distUrlBase": "https://cdn.jsdelivr.net/npm/prebid.js@10.12.0/dist/chunks/",
  "skipCalls": {}
}